import type { CreditBalance } from '@localagent/sdk';

function getColorClass(pct: number): string {
  if (pct > 50) return 'bg-success';
  if (pct > 10) return 'bg-warning';
  return 'bg-error';
}

export function CreditUsageCard({
  balance,
  includedCredits,
  periodEnd,
}: {
  balance: CreditBalance;
  includedCredits: number;
  periodEnd: string;
}) {
  const remaining = balance.available_credits;
  const pct = includedCredits > 0 ? Math.round((remaining / includedCredits) * 100) : 0;
  const consumed = includedCredits - remaining;
  const consumedPct = includedCredits > 0 ? Math.min(100, Math.round((consumed / includedCredits) * 100)) : 0;

  const now = new Date();
  const end = new Date(periodEnd);
  const daysRemaining = Math.max(0, Math.ceil((end.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)));

  return (
    <div className="rounded-lg bg-card p-4 space-y-3">
      <div className="flex items-center justify-between">
        <h3 className="text-label font-medium text-muted-foreground">Credit Usage</h3>
        <span className="text-caption text-muted-foreground">{daysRemaining} days remaining</span>
      </div>
      <div className="flex items-baseline gap-2">
        <span className="text-title-1 font-semibold">{remaining.toLocaleString()}</span>
        <span className="text-body text-muted-foreground">/ {includedCredits.toLocaleString()} credits</span>
        <span className="text-body text-muted-foreground">({pct}% remaining)</span>
      </div>
      <div className="h-2 w-full rounded-full bg-muted overflow-hidden">
        <div
          className={`h-full rounded-full transition-all ${getColorClass(pct)}`}
          style={{ width: `${consumedPct}%` }}
        />
      </div>
    </div>
  );
}
